import { Ref } from "vue";

interface UseInputPopoverInteractionsOptions {
  toggleOnClick?: boolean;
}

export const useInputPopoverInteractions = (
  openModelValue: Ref<boolean>,
  options: UseInputPopoverInteractionsOptions = {}
) => {
  const { toggleOnClick = true } = options;

  return {
    onTab: () => {
      openModelValue.value = false;
    },
    onEnter: () => {
      openModelValue.value = !openModelValue.value;
    },
    onInputClick: (e: MouseEvent) => {
      if (e instanceof PointerEvent && e.pointerId === -1) return;

      if (toggleOnClick) {
        openModelValue.value = !openModelValue.value;
        return;
      }

      openModelValue.value = true;
    },
  };
};
